<!--
 * @Description: 运营管理 -- 国家渠道设置
 * @Author: mdb
 * @Date: 2022-11-03 14:20:46
 * @LastEditTime: 2022-11-03 18:33:28
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        :needPage="false"
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        ref="tableRef"
        tableId="DcCosLbuCountryChannelSetting"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="需求国家">
              <ParamCodesSelect
                v-model:value="queryForm.paramId"
                :options="paramCodeData.lbu_demand_country"
                placeholder="请选择需求国家"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="云途产品">
              <ParamCodeCascader
                v-model:value="queryForm.paramRefId"
                :options="paramCodeData.lbu_products"
                placeholder="请选择云途产品"
                allowClear
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'lbu_country_channel_add_btn'" type="primary" @click="triggerAddOrEdit()"
            >新增</a-button
          >
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'paramRefIdList'">
            <p v-for="item in text" :key="item">
              <ChannelText appId="cos_lbu" paramCode="lbu_products" :value="item" />
            </p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button v-permission="'lbu_country_channel_edit_btn'" type="link" @click="triggerAddOrEdit(record)"
              >编辑</a-button
            >
            <a-button v-permission="'lbu_country_channel_del_btn'" type="link" @click="handleDelete(record)"
              >删除</a-button
            >
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <CountryChannelModal
    ref="countryChannelModalRef"
    :paramCodeData="paramCodeData"
    @fetch="handleQueryChange('fetch')"
  />
</template>

<script setup lang="ts">
import { ref, reactive, computed, onBeforeMount } from 'vue'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import CountryChannelModal from './CountryChannelModal.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { listByParamCodes } from '@/api/common'
import { countryChannelList, countryChannelDelete } from '@/api/yuntuSales/operationsManage'
import type { ParamCodeItem } from '@/typings/common'

interface LbuCountryChannelSettingParams {
  paramId?: number
  paramRefId?: number
}

// 获取业务参数
const paramCodeData = ref<{ [key: string]: ParamCodeItem[] }>({
  lbu_demand_country: [], // 需求国家
  lbu_products: [] // 云途产品
})
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_demand_country', 'lbu_products']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

const tableRef = ref()
const currentCountryList = ref<number[]>()
const queryForm = reactive<LbuCountryChannelSettingParams>({})
const columns = computed(() => [
  { title: '国家', dataIndex: 'paramId', dicData: paramCodeData.value.lbu_demand_country },
  { title: '云途产品', dataIndex: 'paramRefIdList' },
  { title: '操作人', dataIndex: 'operatorName' },
  { title: '操作时间', dataIndex: 'operationTime' },
  { title: '操作', dataIndex: 'action', fixed: 'right' }
])
const getList = (queryForm: LbuCountryChannelSettingParams, callBack: (res: any) => void) => {
  countryChannelList(queryForm).then((res) => {
    currentCountryList.value = res.data.map((item: any) => item.paramId)
    callBack(res)
  })
}
const countryChannelModalRef = ref()
const triggerAddOrEdit = (record?: any) => {
  countryChannelModalRef.value?.init(currentCountryList.value, record)
}
const handleDelete = (record: any) => {
  Modal.delete({
    onOk() {
      countryChannelDelete({ paramId: record.paramId }).then(() => {
        message.success('删除成功')
        handleQueryChange('fetch')
      })
    }
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuCountryChannelSetting' }
</script>

<style scoped></style>
